import { render, staticRenderFns } from "./VendorView.vue?vue&type=template&id=041f96ec&scoped=true"
import script from "./VendorView.vue?vue&type=script&lang=js"
export * from "./VendorView.vue?vue&type=script&lang=js"
import style0 from "./VendorView.vue?vue&type=style&index=0&id=041f96ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "041f96ec",
  null
  
)

export default component.exports